export default __webpack_public_path__ + "static/media/gt.beb45f22.svg";